import { Navigate } from "react-router-dom";

const HandleCallback = () => {
  let redirectPath = "/nominate";
  return <Navigate to={redirectPath} replace />;
};

export default HandleCallback;
